var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInvesment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 62,
    height: 67,
    viewBox: "0 0 62 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.9468 48.6094C57.234 38.386 52.3391 28.9637 44.9593 21.6844C43.3437 20.1125 42.5374 19.3281 40.7531 18.6031C38.9687 17.875 37.4343 17.875 34.3687 17.875H27.6312C24.5656 17.875 23.0312 17.875 21.2468 18.6031C19.4656 19.3281 18.6531 20.1125 17.0406 21.6844C9.66074 28.9637 4.76588 38.386 3.05307 48.6094C1.53119 57.7906 9.99994 64.75 19.4624 64.75H42.5374C52.0031 64.75 60.4749 57.7906 58.9437 48.6094",
    stroke: "#0B63E5",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M36.0845 36.3719C35.4095 33.875 31.9688 31.625 27.8407 33.3094C23.7126 34.9938 23.0595 40.4094 29.3001 40.9875C32.1251 41.2469 33.9626 40.6844 35.647 42.275C37.3345 43.8625 37.647 48.2844 33.3376 49.475C29.0345 50.6656 24.7688 48.8063 24.3063 46.1625M30.5063 30.35V32.7281M30.5063 49.8406V52.2281M16.1782 9.88437C15.5313 8.94687 14.597 7.67187 16.5282 7.38437C18.5126 7.08437 20.572 8.44063 22.5907 8.41563C24.4126 8.3875 25.3407 7.57813 26.3407 6.42188C27.3907 5.20625 29.0157 2.25 31.0001 2.25C32.9845 2.25 34.6095 5.20625 35.6595 6.42188C36.6595 7.57813 37.5876 8.39062 39.4095 8.4125C41.4282 8.44375 43.4876 7.08437 45.472 7.38125C47.4032 7.67187 46.4688 8.94375 45.822 9.88125L42.9095 14.1281C41.6595 15.9406 41.0376 16.8469 39.7313 17.3625C38.4251 17.8781 36.7407 17.875 33.3688 17.875H28.6313C25.2563 17.875 23.572 17.875 22.2688 17.3625C20.9657 16.85 20.3407 15.9375 19.0907 14.125L16.1782 9.88437Z",
    stroke: "#0B63E5",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvesment);
export default __webpack_public_path__ + "static/media/Invesment.b25e9393754e57133718091bae779ab8.svg";
export { ForwardRef as ReactComponent };